import { render } from "./TeamTelegram.vue?vue&type=template&id=6c625df8&scoped=true"
import script from "./TeamTelegram.vue?vue&type=script&lang=js"
export * from "./TeamTelegram.vue?vue&type=script&lang=js"

import "./TeamTelegram.vue?vue&type=style&index=0&id=6c625df8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c625df8"]])

export default __exports__